/**
 * Branch Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines branch-related routes.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS, USER_ROLES } from 'navigation/constants';

import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

const BranchesPage = lazy(() => import('@/features/branches/ui/pages/branches-page'));
const BranchDetailPage = lazy(() => import('@/features/branches/ui/pages/branch-detail-page'));
const AddBranchPage = lazy(() => import('@/features/branches/ui/pages/add-branch-page'));

export const branchRoutes: RouteGroup = {
  name: 'branches',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: true,
  },
  routes: [
    {
      path: ROUTE_PATHS.BRANCHES,
      component: BranchesPage,
      meta: {
        title: 'branches:page.title',
        icon: 'Building2Icon',
        showInNav: true,
        navOrder: 7,
      },
    },
    {
      path: ROUTE_PATHS.BRANCH_CREATE,
      component: AddBranchPage,
      permission: {
        allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
      },
      meta: {
        title: 'branches:addBranch.title',
        parent: ROUTE_PATHS.BRANCHES,
      },
    },
    {
      path: ROUTE_PATHS.BRANCH_DETAIL,
      component: BranchDetailPage,
      meta: {
        title: 'branches:detail.title',
        parent: ROUTE_PATHS.BRANCHES,
      },
    },
  ],
};
